<template>
  <dl class="acd-block" :class="[`block-${classText}`, {'is-open': isShown}]">
    <dt class="acd-course" role="button" @click="isShown = !isShown">
      <slot name="courseName"></slot>
    </dt>

    <transition name="acdBody" @enter="enter" @after-enter="afterTransition" @leave="leave" @after-leave="afterTransition">
      <dd v-show="isShown" class="acd-body">
        <slot name="courseBody"></slot>
      </dd>
    </transition>

  </dl>
</template>


<script>
function nextFrame(cb) {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(cb)
  })
}

export default {
  name: 'Accordion',

  props: {
    classText: String
  },

  data: () => {
    return {
      isShown: true
    }
  },

  created: function() {
    // console.log(this.classText)
    if(this.classText=='define' || this.classText=='more' ) {
      this.isShown = false
    }
  },

  methods: {
    enter: function(el){
      el.style.overflow = 'hidden'
      const height = el.scrollHeight
      el.style.height = '0'

      nextFrame(() =>{
        el.style.height = height + 'px'
      })
    },

    leave: function(el) {
      el.style.overflow = 'hidden'
      el.style.height = el.scrollHeight + 'px'

      nextFrame(() =>{
        el.style.height = 0
      })
    },

    afterTransition: function(el) {
      el.style.overflow = ''
      el.style.height = ''
    }
  }
}
</script>


<style scoped>
</style>